import { InjectionToken } from '@angular/core';

export const PREVIEW_URL_TOKEN = new InjectionToken<string>('PREVIEW_URL_TOKEN');